import { Card } from 'antd';

import { type FormBuilderOptionItem, GenericForm } from '@/components/generic-form';
import { getTranslatedString } from '@/utils';
import { getFormattedPriceWithCurrency } from '@/utils/formatters';
import { getFormattedDate, getFormattedRangeDate } from '@/utils/moment';

const getDisabledFields = (fields: FormBuilderOptionItem[]) =>
  fields.map((item: FormBuilderOptionItem) => ({
    ...item,
    params: { ...item.params, readOnly: true, style: { marginBottom: 5 } },
  }));

export const CardReadOnlyForm = ({ i18nTitle, initialValues, formFields }) => {
  const getNormalizedBvValues = (values: any) => {
    return values
      ? {
          ...values,
          ...(Object.hasOwn(values, 'acceptanceDate') &&
            values.acceptanceDate && { acceptanceDate: getFormattedDate(values.acceptanceDate) }),
          ...(Object.hasOwn(values, 'expirationDate') &&
            values.expirationDate && { expirationDate: getFormattedDate(values.expirationDate) }),
          period: values?.period && getFormattedRangeDate(values?.period),
          price: values?.price && getFormattedPriceWithCurrency(values?.price, null),
        }
      : {};
  };

  const layout = {
    labelCol: {},
    wrapperCol: {},
  };

  return (
    <Card className="card-shadow" title={getTranslatedString(i18nTitle)} bordered={false} size="small">
      <GenericForm
        {...layout}
        initialValues={getNormalizedBvValues(initialValues)}
        formFields={getDisabledFields(formFields)}
      />
    </Card>
  );
};
